export default __webpack_public_path__ + "static/media/jenkins.7f4f6ffc.svg";